import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationService } from '../notification/notification.service';

// Interface for socket messages
export interface SocketMessage {
  status: 'success' | 'fail';
  data: string;
}

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(
    private socket: Socket,
    private notifyService: NotificationService
  ) {
    this.listenSocketEvents();
  }

  /** --- Emit a message to the server --- */
  sendMessage(msg: string): void {
    this.socket.emit('msg', msg);
  }

  /** --- Listen to messages from server --- */
  getMessage(): Observable<SocketMessage> {
    // Cast the received data to SocketMessage
    return this.socket
      .fromEvent('msg')
      .pipe(
        map((data) => {
          console.log('Socket message received:', data);
          return data as SocketMessage;
        })
      );
  }

  /** --- Listen to connect/disconnect events --- */
  getSocketEvent(): Observable<'connected' | 'disconnected'> {
    return new Observable(observer => {
      this.socket.on('connect', () => observer.next('connected'));
      this.socket.on('disconnect', () => observer.next('disconnected'));

      // Cleanup when unsubscribed
      return () => {
        this.socket.off('connect');
        this.socket.off('disconnect');
      };
    });
  }

  /** --- Optional communication channel --- */
  getCommunicationStatus(): Observable<any> {
    return this.socket
      .fromEvent('communication')
      .pipe(map(data => data.msg));
  }

  /** --- Internal listener for showing notifications --- */
  private listenSocketEvents(): void {
    this.getSocketEvent().subscribe(event => {
      if (event === 'disconnected') {
        this.notifyService.hideInfoToast();
        this.notifyService.hideSuccessToast();
        this.notifyService.showErrorWithTimeout(
          'Connection Lost, Please wait',
          ''
        );
      } else if (event === 'connected') {
        console.log('Socket connected to server.');
      }
    });
  }

  /** --- Optional: disconnect socket manually --- */
  disconnect(): void {
    this.socket.disconnect();
  }

  /** --- Optional: reconnect socket manually --- */
  reconnect(): void {
    this.socket.connect();
  }
}
